import { Box, Grid } from '@mui/material';
import * as React from 'react';
import { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { prevent } from '../utils/generics';

type MediaDotsIndicatorProps = {
  dots: number;
  selectedIndex: number;
  onChangeIndex: (index: number) => void;
  classes?: {
    root?: string;
  };
};

const useStyles = makeStyles()((theme) => ({
  mobileIndicator: {
    position: 'absolute',
    width: 'fit-content',
    left: '50%',
    bottom: theme.spacing(2),
    transform: 'translateX(-50%)',
    zIndex: 998,
  },
  mobileIndicatorItem: {
    width: theme.spacing(1),
    height: theme.spacing(1),
    borderRadius: '50%',
    background: theme.palette.grey[400],
  },
  mobileIndicatorItemActive: {
    background: theme.palette.primary.main,
  },
}));

const MediaDotsIndicator = ({
  dots,
  selectedIndex,
  onChangeIndex,
  classes: externalClasses,
}: MediaDotsIndicatorProps) => {
  const { classes, cx } = useStyles();

  const handleChangeIndex = (e: React.SyntheticEvent, index: number) => {
    prevent(e);
    onChangeIndex(index);
  };

  const createArrayFromNumberOfDots = useCallback(() => Array.from(Array(dots).keys()), [dots]);

  return (
    <Grid container className={cx(classes.mobileIndicator, externalClasses?.root)} spacing={1}>
      {createArrayFromNumberOfDots().map((item, index) => (
        <Grid key={item} onClick={(e) => handleChangeIndex(e, index)}>
          <Box
            className={cx(
              classes.mobileIndicatorItem,
              selectedIndex === index && classes.mobileIndicatorItemActive,
            )}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default MediaDotsIndicator;
